import _toConsumableArray from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AppLauncher/app-launcher';
import formStyles from '@patternfly/react-styles/css/components/FormControl/form-control';
import ThIcon from '@patternfly/react-icons/dist/js/icons/th-icon';
import { DropdownDirection, DropdownPosition, DropdownToggle, DropdownContext } from '../Dropdown';
import { DropdownWithContext } from '../Dropdown/DropdownWithContext';
import { ApplicationLauncherGroup } from './ApplicationLauncherGroup';
import { ApplicationLauncherSeparator } from './ApplicationLauncherSeparator';
import { ApplicationLauncherItem } from './ApplicationLauncherItem';
import { ApplicationLauncherContext } from './ApplicationLauncherContext';
export var ApplicationLauncher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ApplicationLauncher, _React$Component);

  function ApplicationLauncher() {
    var _this;

    _classCallCheck(this, ApplicationLauncher);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ApplicationLauncher).apply(this, arguments));

    _this.createSearchBox = function () {
      var _this$props = _this.props,
          onSearch = _this$props.onSearch,
          searchPlaceholderText = _this$props.searchPlaceholderText,
          searchProps = _this$props.searchProps;
      return React.createElement("div", {
        key: "search",
        className: css(styles.appLauncherMenuSearch)
      }, React.createElement(ApplicationLauncherItem, {
        customChild: React.createElement("input", Object.assign({
          type: "search",
          className: css(formStyles.formControl),
          placeholder: searchPlaceholderText,
          onChange: function onChange(e) {
            return onSearch(e.target.value);
          }
        }, searchProps))
      }));
    };

    _this.createRenderableFavorites = function () {
      var _this$props2 = _this.props,
          items = _this$props2.items,
          isGrouped = _this$props2.isGrouped,
          favorites = _this$props2.favorites;

      if (isGrouped) {
        var favoriteItems = [];
        items.forEach(function (group) {
          return group.props.children.filter(function (item) {
            return favorites.includes(item.props.id);
          }).map(function (item) {
            return favoriteItems.push(React.cloneElement(item, {
              isFavorite: true,
              enterTriggersArrowDown: true
            }));
          });
        });
        return favoriteItems;
      }

      return items.filter(function (item) {
        return favorites.includes(item.props.id);
      }).map(function (item) {
        return React.cloneElement(item, {
          isFavorite: true,
          enterTriggersArrowDown: true
        });
      });
    };

    _this.extendItemsWithFavorite = function () {
      var _this$props3 = _this.props,
          items = _this$props3.items,
          isGrouped = _this$props3.isGrouped,
          favorites = _this$props3.favorites;

      if (isGrouped) {
        return items.map(function (group) {
          return React.cloneElement(group, {
            children: React.Children.map(group.props.children, function (item) {
              if (item.type === ApplicationLauncherSeparator) {
                return item;
              }

              return React.cloneElement(item, {
                isFavorite: favorites.some(function (favoriteId) {
                  return favoriteId === item.props.id;
                })
              });
            })
          });
        });
      }

      return items.map(function (item) {
        return React.cloneElement(item, {
          isFavorite: favorites.some(function (favoriteId) {
            return favoriteId === item.props.id;
          })
        });
      });
    };

    return _this;
  }

  _createClass(ApplicationLauncher, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          ariaLabel = _a['aria-label'],
          isOpen = _a.isOpen,
          onToggle = _a.onToggle,
          toggleIcon = _a.toggleIcon,
          toggleId = _a.toggleId,
          onSelect = _a.onSelect,
          isDisabled = _a.isDisabled,
          className = _a.className,
          isGrouped = _a.isGrouped,
          favorites = _a.favorites,
          onFavorite = _a.onFavorite,
          onSearch = _a.onSearch,
          items = _a.items,
          searchPlaceholderText = _a.searchPlaceholderText,
          searchProps = _a.searchProps,
          ref = _a.ref,
          favoritesLabel = _a.favoritesLabel,
          searchNoResultsText = _a.searchNoResultsText,
          props = __rest(_a, ['aria-label', "isOpen", "onToggle", "toggleIcon", "toggleId", "onSelect", "isDisabled", "className", "isGrouped", "favorites", "onFavorite", "onSearch", "items", "searchPlaceholderText", "searchProps", "ref", "favoritesLabel", "searchNoResultsText"]);

      var renderableItems = [];

      if (onFavorite) {
        var favoritesGroup = [];
        var renderableFavorites = [];

        if (favorites.length > 0) {
          renderableFavorites = this.createRenderableFavorites();
          favoritesGroup = [React.createElement(ApplicationLauncherGroup, {
            key: "favorites",
            label: favoritesLabel
          }, renderableFavorites, React.createElement(ApplicationLauncherSeparator, {
            key: "separator"
          }))];
        }

        if (renderableFavorites.length > 0) {
          renderableItems = favoritesGroup.concat(this.extendItemsWithFavorite());
        } else {
          renderableItems = this.extendItemsWithFavorite();
        }
      } else {
        renderableItems = items;
      }

      if (items.length === 0) {
        renderableItems = [React.createElement(ApplicationLauncherGroup, {
          key: "no-results-group"
        }, React.createElement(ApplicationLauncherItem, {
          key: "no-results"
        }, searchNoResultsText))];
      }

      if (onSearch) {
        renderableItems = [this.createSearchBox()].concat(_toConsumableArray(renderableItems));
      }

      return React.createElement(ApplicationLauncherContext.Provider, {
        value: {
          onFavorite: onFavorite
        }
      }, React.createElement(DropdownContext.Provider, {
        value: {
          onSelect: onSelect,
          menuClass: styles.appLauncherMenu,
          itemClass: styles.appLauncherMenuItem,
          toggleClass: styles.appLauncherToggle,
          baseClass: styles.appLauncher,
          baseComponent: 'nav',
          sectionClass: styles.appLauncherGroup,
          sectionTitleClass: styles.appLauncherGroupTitle,
          sectionComponent: 'section',
          disabledClass: styles.modifiers.disabled
        }
      }, React.createElement(DropdownWithContext, Object.assign({}, props, {
        dropdownItems: renderableItems,
        isOpen: isOpen,
        className: className,
        "aria-label": ariaLabel,
        toggle: React.createElement(DropdownToggle, {
          id: toggleId,
          toggleIndicator: null,
          isOpen: isOpen,
          onToggle: onToggle,
          isDisabled: isDisabled,
          "aria-label": ariaLabel
        }, toggleIcon),
        isGrouped: isGrouped
      }))));
    }
  }]);

  return ApplicationLauncher;
}(React.Component);
ApplicationLauncher.defaultProps = {
  className: '',
  isDisabled: false,
  direction: DropdownDirection.down,
  favorites: [],
  isOpen: false,
  position: DropdownPosition.left,

  /* eslint-disable @typescript-eslint/no-unused-vars */
  onSelect: function onSelect(_event) {
    return undefined;
  },
  onToggle: function onToggle(_value) {
    return undefined;
  },

  /* eslint-enable @typescript-eslint/no-unused-vars */
  'aria-label': 'Application launcher',
  isGrouped: false,
  toggleIcon: React.createElement(ThIcon, null),
  searchPlaceholderText: 'Filter by name...',
  searchNoResultsText: 'No results found',
  favoritesLabel: 'Favorites'
};